var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-flex',{staticClass:"dhw-temperature-measurements"},[_c('domain-ui-dhw-temperature-widget',{attrs:{"heating-temperature-main":_vm.heatingTemperatureMain,"hot-water-storage-temperature":_vm.hotWaterStorageTemperature}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }